
import { ChangeDetectorRef, Component, HostListener, Injectable, OnInit, ViewEncapsulation } from '@angular/core';


import * as utilities from 'libs/shared-lib1/src/lib/shared/utilities'
//import { sharedText } from '@nxt/shared-lib1'

import { SharedLib1Module } from '@nxt/shared-lib1'
import { SharedCompComponent } from 'libs/shared-lib1/src/lib/shared-comp/shared-comp.component';
import { App1Service } from '../services/app1.service';
import { Subscription } from 'rxjs';
import {
  Router, NavigationStart, NavigationEnd,
  NavigationCancel, NavigationError, Event
} from '@angular/router';
import { App1WrapperService } from './services/app1-wrapper.service';
import { MsgsToUserService } from 'libs/shared-lib1/src/lib/msgs-to-user.service';
import { MsgToUser } from 'libs/shared-lib1/src/lib/msgs-to-user/models/MsgToUser.model';
import { AuthService } from 'libs/shared-auth/src/services/auth.service';
import BaseTokenService from 'libs/shared-lib1/src/lib/shared/baseToken.service';
import { ConfigService } from 'libs/shared-lib1/src/lib/shared/services/config-service.service';
import { LocationStrategy } from '@angular/common';
import { Location } from '@angular/common';
import { environment } from '../environments/environment';
import { App1ConfigSettings } from 'libs/shared-lib1/src/lib/shared/models/app1ConfigSettings';

@Component({
  selector: 'app1-wrapper-nxt-root',
  templateUrl: './app1Wrapper.component.html',
  styleUrls: ['./app1Wrapper.component.scss'],
  //encapsulation: ViewEncapsulation.None
})

@Injectable()
export class App1WrapperComponent implements OnInit {

  configsForApp: App1ConfigSettings;
  showLoadingIndicator = false;
  isLoggedIn: boolean = false;

  title = 'app1' + utilities.sharedText;
  app2Url: any;  

  constructor(
    private authService: AuthService,
    private msgsToUserService: MsgsToUserService,
    private app1WrapperService: App1WrapperService,
    private baseTokenService: BaseTokenService,
    private configService: ConfigService,
    private location: Location,
    private locationStrategy: LocationStrategy,
    private cdr: ChangeDetectorRef
  ) {


  }

  ngOnInit() {

    this.showLoadingIndicator = true;

    this.configsForApp = this.configService.app1ConfigSettings;
    let envName: string = this.configService.app1ConfigSettings.envName;

    if (this.configsForApp.shouldEnforceLogin == false) {

      this.isLoggedIn = true;
      this.showLoadingIndicator = false;

    } else {

      this.setSubscribers();

    }

    this.setApp2Url(envName);

  }

  setApp2Url(envName: string) {

    if (envName.toLowerCase() == "local") {
      //this.app2Url = "http://localhost:4202/app2/#app2/";
      this.app2Url = "http://localhost:4202";

    } else {

      let hostUrl: string = window.location.host;

      if (hostUrl.includes("web.core.windows.net")) { //azure

        this.app2Url = location.origin + "/app2/#app2/";

      } else if (hostUrl.includes("itai-nx-test")) { //Firebase https://itai-nx-test-app1.web.app/

        this.app2Url = "https://itai-nx-test-app2.web.app";

      }


    }
  }

  setSubscribers() {

    if (this.configsForApp.shouldEnforceLogin == true) {

      this.authService.isLoggedInAsObservable.subscribe((isLoggedIn: boolean) => {

        if (isLoggedIn != null) {

          var isValidTokenAndLoggedIn = this.baseTokenService.isValidToken();

          if (isValidTokenAndLoggedIn) {

            this.showLoadingIndicator = false;

            this.isLoggedIn = true;

            this.subscribeToRouteChanges();

          } else { //not loggedIn

            this.isLoggedIn = false;

          }

        }

      });

    }

    this.cdr.detectChanges();

  }

  subscribeToRouteChanges() {

    // Subscribe to the router events observable
    this.app1WrapperService.router.events.subscribe((routerEvent: Event) => {

      if (routerEvent instanceof NavigationStart) {
        // On NavigationStart, set showLoadingIndicator to true

        this.showLoadingIndicator = true;

        // //if we already displayed an HTTP error msg on a page, and now leaving it,
        // //when we leave that page (navigation started) and later go back we want to see the error again
        // //Therefore we reset the property indicating if msg was presented.
        // if (this.app1WrapperService.handleHttpErrorService.gotDisplayedToUser) {

        //   this.resetHttpErrorToReDisplay();

        // }

      }

      // On NavigationEnd or NavigationError or NavigationCancel
      // set showLoadingIndicator to false
      if (routerEvent instanceof NavigationEnd ||
        routerEvent instanceof NavigationError ||
        routerEvent instanceof NavigationCancel) {

        this.showLoadingIndicator = false;

        this.closeAnyToasterMsgs()

      }

    });

  }

  closeAnyToasterMsgs() {

    // const msg = "error in the api call...";
    // const color = "red";

    const msgToUser: MsgToUser = new MsgToUser(null, null);

    this.msgsToUserService.setMsgsToUser(msgToUser);

  }

}
